// extracted by mini-css-extract-plugin
module.exports = {"input":"custom-input_input__2Pvml","required":"custom-input_required__HY4ao"};